import { Organization } from "../organization";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { CallCenterFaqItemEntityConfig } from "./config";
import { CallCenterFaqItemFilters } from "./filters";
import { CallCenterFaqItemMethods } from "./methods";

@HyperEntity<CallCenterFaqItem>(
  "call-center-faq-item",
  CallCenterFaqItemEntityConfig,
)
export class CallCenterFaqItem extends extender(
  CallCenterFaqItemFilters,
  CallCenterFaqItemMethods,
) {
  @Fields.id()
  id = "";

  @Fields.string({ dbName: "organization_id", caption: "ארגון" })
  organizationId = "";

  @Relations.toOne(() => Organization, "organizationId")
  organization?: Organization;

  @Fields.string({ caption: "שאלה" })
  question = "";

  @Fields.string({ caption: "תשובה" })
  answer = "";

  @Fields.integer({ dbName: "sort_order", caption: "סדר" })
  sortOrder = 0;

  @Fields.boolean({ dbName: "is_active", caption: "פעיל" })
  isActive = true;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
